<template>
    <div
        class="w-full flex items-center justify-center mx-auto py-4 bg-won-blue pl-6"
    >
        <img 
            src="/img/beach-comute-logo.png" 
            alt="WonsultingAi-Logo" 
            class="h-9 mr-4"
        >
        <span class="text-white text-xl">X</span>
        <img 
            :src="'/img/logo.svg?id=36d75e6e63946874eae5'" 
            alt=""
            class="w-auto h-8 ml-4" 
            style="filter: brightness(0) invert(1)"
        >
    </div>
</template>
